export const locale = {
    lang: 'pl',
    data: {
        'Workers': 'Pracownicy',
        'New': 'Nowy',
        'First name': 'Imię',
        'Last name': 'Nazwisko',
        'Username': 'Nazwa użytkownika',
        'User data': 'Dane użytkownika',
        'First Name is required!': 'Imię jest wymagane',
        'Last Name is required!': 'Nazwisko jest wymagane',
        'User name is required!': 'Nazwa użytkownika jest wymagana',
        'E-mail is required!': 'E-mail jest wymagany',
        'Card number': 'Numer karty',
        'Phone': 'Telefon',
        'Password': 'Hasło',
        'Street': 'Ulica',
        'House number': 'Numer domu',
        'Flat number': 'Numer mieszkania',
        'Post code': 'Kod pocztowy',
        'Password is required!': 'Hasło jest wymagane',
        'City': 'Miasto',
        'Country': 'Państwo',
        'Role': 'Uprawnienia',
        'Save': 'Zapisz',
        'ROLE_RECEPTIONIST': 'Recepcjonista',
        'ROLE_ADMIN': 'Administrator',
        'ROLE_MANAGER': 'Menadżer',
        'ROLE_SUPER_ADMIN': 'Super administrator',
        'ROLE_WORKER': 'Pracownik',
        'ROLE_TRAINER': 'Trener',
        'Actions': 'Akcje',
        'Edit': 'Edycja',
        'Services': 'Usługi',
        'Employee schedule': 'Grafik',
        'Summary': 'Podsumowanie',
        'Personal data': 'Dane dodatkowe',
        'Birthday': 'Data urodzenia',
        'Created at': 'Data dodania',
        'Cards': 'Karty',
        'Delete': 'Usuń',
        'Type to filter users list...': 'Wyszukaj użytkownika...',
        'Type to filter trainers list...': 'Wyszukaj trenera...',
        'Cards quantity': 'Ilość kart',
        'Visible in calendar': 'Widoczny w kalendarzu',
        'Yes': 'Tak',
        'No': 'Nie',
        'Worker': 'Pracownik',
        'In calendar': 'W kalendarzu',
        'Recharge setup': 'Konfiguracja doładowań',
        'Visible in scheduler': 'Widoczny w grafiku'
    }
};
